function injectScript(content) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.charset = 'utf-8';
    script.text = content;
    document.head.appendChild(script);
  });
};

export default injectScript;
